module.exports = __webpack_public_path__ + "img/indicate_icon_3.28d21f9a.png";